import React from "react";
import DND from "../pages/canvas/paper/dndhandler";
import Render from "../pages/canvas/paper/render";

export default function Floating(props) {
  return (
    <div
      ref={props.editorRef}
      style={{
        display: "flex",
        flexWrap: "wrap",
        position: "absolute",
        boxSizing: "border-box",
        zIndex: 1,
        left: props.block.props.left,
        top: props.block.props.top,
        right: props.block.props.right,
        bottom: props.block.props.bottom,
        visibility: props.block.hidden ? "hidden" : "unset",
        backgroundColor: props.block.props.backgroundColor,
        justifyContent: props.block.props.justifyContent,
        alignItems: props.block.props.alignItems,
        overflowY: "scroll",
        boxShadow: props.block.props.boxShadow,
        ...props.block.props.spacing,
        ...props.block.props.border,
        ...props.block.props.size,
      }}
    >
      {props.children.map((block, index) => {
        const newPath = [...props.path];
        newPath.push(index);

        return (
          <DND
            key={block.id}
            disabled={props.disabled}
            block={block}
            path={newPath}
            index={index}
          >
            <Render />
          </DND>
        );
      })}
    </div>
  );
}
